import {Col, Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    padding: 12px 20px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
    z-index: 3;
    gap: 10px;
    border: 2px solid #aeef01;
    flex-shrink: 0;

    @media (max-width: 768px) {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 10px;
    }
`;

export const LeftSection = styled(Col)`
    display: flex;
    flex-direction: row;
`;

export const InfoRow = styled(Col)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: 2;
    font-weight: 600;
    z-index: 5;
    cursor: pointer;
    white-space: nowrap;
    overflow: ${props => (props.$noWidth ? "visible" : "hidden")};
    text-overflow: ellipsis;
    min-width: 0;
    margin-bottom: 16px;
`;

export const InfoRowForUpload = styled(Col)`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex: ${props => (props.$noWidth ? "0 0 auto" : "1")};
    font-weight: 600;
    z-index: 5;
    cursor: pointer;
    white-space: nowrap;
    overflow: ${props => (props.$noWidth ? "visible" : "hidden")};
    text-overflow: ellipsis;
    min-width: 0;
`;

export const InfoIcon = styled.img`
    margin-right: 5px;
    height: 14px;
    flex-shrink: 0;
`;

export const InfoSeperator = styled.div`
    width: 100%;
    height: 1px;
    margin: 15px 0;
    background-color: #d9d9d9;
`;

export const SectionTab = styled.div`
    width: auto;
    height: auto;
    background-color: #fff;
    position: absolute;
    border-radius: 10px;
    //figma dropshadow x:3 y:4 bluer:10.8 spread:0 color:rgba(0,0,0,0.25)
    box-shadow: 3px 4px 10.8px 0px rgba(0, 0, 0, 0.25);
    top: -25px;
    left: 8px;
    padding: 3px 6px 20px 6px;
    z-index: -1;
    font-weight: 700;
    display: flex;
    justify-content: center;
    flex-shrink: 0;
`;

export const SectionIcon = styled.img`
    margin-right: 5px;
    flex-shrink: 0;
`;

// Contracts styling
export const ContractsInfoItem = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 12px;

    .contracts-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }

    .contract-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        font-size: 16px;
        color: #389e0d;
        min-width: 200px;

        b {
            font-weight: 600;
        }

        .contract-amount {
            min-width: 60px;
            text-align: right;
        }
    }

    @media (max-width: 768px) {
        gap: 16px;

        .contracts-list {
            width: 100%;
        }

        .contract-row {
            font-size: 14px;
            min-width: 100%;
            gap: 8px;

            b {
                font-size: 14px;
            }

            .contract-amount {
                min-width: auto;
                text-align: right;
                white-space: nowrap;
            }
        }
    }
`;

// Bakiye section styling
export const BalanceSection = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 16px;

    .balance-info {
        display: flex;
        align-items: center;
        gap: 8px;
        cursor: pointer;
        flex: 1;
        min-width: 0;
    }

    .balance-value {
        font-size: 16px;
        font-weight: bold;
        color: #333;
        min-width: 120px;
    }

    .balance-load-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        white-space: nowrap;
        flex-shrink: 0;
    }

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
        justify-content: center;
        flex-wrap: wrap;

        .balance-info {
            width: 100%;
            gap: 12px;
            justify-content: center;
            align-items: center;
        }

        .balance-value {
            font-size: 14px;
            min-width: auto;
            width: 100%;
        }

        .balance-load-btn {
            width: 100%;
            justify-content: center;
            padding: 8px 12px;
            background: #f0f0f0;
            border-radius: 8px;
            transition: all 0.3s ease;

            &:hover {
                background: #e0e0e0;
            }

            img {
                width: 16px !important;
                height: 16px !important;
            }
        }
    }
`;
